/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as LogoutSvg } from "../../../resources/images/logout-icon-lep.svg";

/* Styles */
import styles from "./styles";

const LepUnsavedChangesModal = ({
  showUnsavedChangesModal,
  setShowUnsavedChangesModal,
  setAssignModalShow
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.unsavedChangesModal}
      customStyle={classes.unsavedChangesModalWrapper}
      showModal={showUnsavedChangesModal}
      setShowModal={setShowUnsavedChangesModal}
      modalIcon={<LogoutSvg />}
      modalTitle={<FormattedMessage id="lepUnsavedChangesModal.title" />}
      modalDescription={<FormattedMessage id="lepUnsavedChangesModal.description" />}
      modalContent={<Content setShowModal={setShowUnsavedChangesModal} setAssignModalShow={setAssignModalShow}/>}
    />
  );
};

export default LepUnsavedChangesModal;
